import { Injectable } from '@angular/core';
import { 
    HttpInterceptor, 
    HttpRequest, 
    HttpHandler, 
    HttpClient, 
    HttpEvent, 
    HttpErrorResponse, 
    HttpContextToken, 
    HttpContext 
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

@Injectable()
export class SubscriptionStateInterceptor implements HttpInterceptor {

  private readonly CHECK_SUBSCRIPTION_URL = environment.serverUrl + 'ws/index.php?p1=user&p2=checkSubscriptionState';

  private readonly SKIP_SUBSCRIPTION_CHECK = new HttpContextToken<boolean>(() => false);

  constructor(private readonly router: Router, private readonly http: HttpClient) {void http;}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.appName !== 'agrogestSIEX' || req.context.get(this.SKIP_SUBSCRIPTION_CHECK)) {
      return next.handle(req);
    }

    const username = StorageManager.getUser()?.username ?? '';

    return this.http.get<{ data: string }>(
        this.CHECK_SUBSCRIPTION_URL, 
    {
      params: { username },
      context: new HttpContext().set(this.SKIP_SUBSCRIPTION_CHECK, true)
    }).pipe(
      switchMap(subscription => {
        if (subscription.data === 'expired') {
            StorageManager.deleteUser();
            this.router.navigate(['register'], {queryParams: { estado: 'expired' }});
        }
        
        return next.handle(req);
      }),
      catchError((error: HttpErrorResponse) => 
         throwError(() => error)
      )
    );
  }
}
